class HttpUtil {};
// 打包时要把apiUrl 改为"/"
// var apiUrl = "http://104.244.94.191:9000/";
var apiUrl = "/";
// var payUrl = "http://104.244.94.191:9000/";
var payUrl = "/"
HttpUtil.request = function (url, dataJson, requestMethodStr, cb, timeOut, body = null) {
    var self = this;
    url = apiUrl + "api/" + url;
    //console.log('request url ' + url);
    //console.log('request dataJson ' + dataJson);
    var dataStr = "";
    var firstEnter = true;
    for (var key in dataJson) {
        if (!firstEnter) dataStr += "&";
        firstEnter = false;
        var value = dataJson[key];
        dataStr += key;
        dataStr += "=";
        dataStr += value;
    }
    //console.log('request dataStr ' + dataStr);
    if (!timeOut) {
        timeOut = 30000;
    }
    try {
        var response = false;
        setTimeout(function () {
            if (response == false) {
                cb("超时了", null);
            }
        }, timeOut);

        self.xhr = new XMLHttpRequest();
        self.xhr.onreadystatechange = function () {
            //console.log('request self.xhr.readyState ' + self.xhr.readyState);
            //console.log('request self.xhr.status ' + self.xhr.status);
            //if (self.xhr.readyState == 4 && self.xhr.status >= 200 && self.xhr.status < 400) {
            if (self.xhr.readyState == 4) {
                response = true;
                console.log('self.xhr.responseText = ' + self.xhr.responseText);
                cb(null, JSON.parse(self.xhr.responseText));
            }
        };
        var finalUrl = dataStr == "" ? url : url + "?" + dataStr;

        // console.log('finalUrl ' + finalUrl);

        finalUrl = encodeURI(finalUrl);
        self.xhr.open(requestMethodStr, finalUrl, true);
        //self.xhr.withCredentials = true;
        //

        if (cc.gameSpace.token && cc.gameSpace.token != "") {
            self.xhr.setRequestHeader("Authorization", "Bearer " + cc.gameSpace.token);
        }
        self.xhr.setRequestHeader('accept', 'application/json');
        self.xhr.setRequestHeader('Content-type', 'application/json');
        self.xhr.send(body);
        // JSON.stringify({
        // password: "",
        // username: ""
        // })
    } catch (e) {
        cb(e, null);
    }
}

//延迟多久没回复就返回False
HttpUtil.TimeOut = 200;

/**
 * GET请求
 *
 * @static
 * @param {*} url
 * @param {object} [params={}]
 * @param {*} callback
 * @memberof HttpUtil
 */
HttpUtil.GET = function (url, params, callback) {
    let dataStr = '';
    Object.keys(params).forEach(key => {
        dataStr += key + '=' + encodeURIComponent(params[key]) + '&';
    })
    if (dataStr !== '') {
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
        url = url + '?' + dataStr;
    }
    // url = HttpUtil.baseUrl + url;

    let xhr = cc.loader.getXMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            let response = xhr.responseText;
            if (xhr.status >= 200 && xhr.status < 300) {
                let httpStatus = xhr.statusText;
                // callback(true, JSON.parse(response));
                callback(true, response);
            } else {
                callback(false, response);
            }
        }
    };
    xhr.timeout = this.TimeOut;
    xhr.send();
}


/**
 * POST请求
 *
 * @static
 * @param {*} url
 * @param {object} [param={}]
 * @param {*} callback
 * @memberof HttpUtil
 */
HttpUtil.POST = function (url, param, callback) {
    // url = HttpUtil.baseUrl + url;
    var xhr = cc.loader.getXMLHttpRequest();
    let dataStr = '';
    Object.keys(param).forEach(key => {
        dataStr += key + '=' + encodeURIComponent(param[key]) + '&';
    })
    if (dataStr !== '') {
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
    }
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            let response = xhr.responseText;
            if (xhr.status >= 200 && xhr.status < 300) {
                let httpStatus = xhr.statusText;
                // callback(true, JSON.parse(response));
                callback(true, response);

            } else {
                callback(false, response);
            }
        }
    };
    xhr.send(dataStr);
}

HttpUtil.openPay = function (url) {
    url = payUrl + "pay?" + url;
    cc.sys.openURL(url)
}

module.exports = HttpUtil;